import React from "react";
import { Table } from "../../../ui/Table";
import PropTypes from "prop-types";
import { FormatCurrency3Dec } from "../../../../utils/FormatData";

const TableCustomers = ({ data, loading = false }) => {
  const COLUMNS = [
    {
      Header: "Periodo",
      accessor: "vc_period",
    },
    {
      Header: "Cliente",
      accessor: "vc_customer",
    },
    {
      Header: "Partner",
      accessor: "vc_partner",
    },
    {
      Header: "Total de SMS",
      accessor: "i_totalsms",
    },
    {
      Header: "RCS Básico",
      accessor: "i_basic",
    },
    {
      Header: "RCS Simple",
      accessor: "i_singles",
    },
    {
      Header: "RCS",
      accessor: "i_rcs",
    },
    {
      Header: "Fallback(SMS)",
      accessor: "i_fallback",
    },
    {
      Header: "Precio unitario",
      accessor: "n_unitprice",
      Cell: (rowData) => {
        let value = rowData.row.original.n_unitprice;

        return FormatCurrency3Dec(value);
      },
    },
    {
      Header: "Monto ($)",
      accessor: "n_amount",
      Cell: (rowData) => {
        let value = rowData.row.original.n_amount;

        return FormatCurrency3Dec(value);
      },
    },
  ];

  return (
    <Table
      data={data}
      loading={loading}
      columns={COLUMNS}
      config={{
        search: true,
        footer: true,
        pageSize: 10,
        perPage: 10,
        export: true,
      }}
    />
  );
};
TableCustomers.propTypes = {
  data: PropTypes.array,
  loading: PropTypes.bool,
};
export default TableCustomers;
